import { Link } from 'react-router-dom';

interface Comic {
  id: number;
  title: string;
  author: string;
  artist: string;
  category: string;
  categoryName: string;
  cover: string;
  rating: number;
  views: string;
  status: string;
  chapters: number;
  updatedAt: string;
  description?: string;
  tags?: string[];
}

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[140px] h-[196px]',
    medium: 'w-[180px] h-[252px]',
    large: 'w-[200px] h-[280px]',
  };

  const titleSizes = {
    small: 'text-sm',
    medium: 'text-[15px]',
    large: 'text-base',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop=""
    >
      <div className={`${coverSizes[size]} relative overflow-hidden rounded-lg mb-3 flex-shrink-0`}>
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 韩漫在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-start p-3">
          <span className="text-white text-xs font-medium bg-primary-500 px-2.5 py-1 rounded-full whitespace-nowrap">
            立即阅读
          </span>
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-foreground-700 text-white text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            完结
          </span>
        )}
        <div className="absolute top-2 right-2 bg-black/70 text-accent-400 text-[10px] font-medium px-1.5 py-0.5 rounded flex items-center gap-0.5 whitespace-nowrap">
          <i className="ri-star-fill text-[8px]"></i>
          {comic.rating}
        </div>
      </div>

      <h3 className={`${titleSizes[size]} font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug mb-1`}>
        {comic.title}
      </h3>

      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span className="whitespace-nowrap">{comic.author}</span>
        <span className="text-foreground-300">·</span>
        <span className="whitespace-nowrap">{comic.categoryName}</span>
      </div>

      {size !== 'small' && (
        <div className="flex items-center gap-2 mt-1.5 text-[11px] text-foreground-400">
          <span className="flex items-center gap-0.5">
            <i className="ri-eye-line text-[10px]"></i>
            {comic.views}
          </span>
          <span>·</span>
          <span className="whitespace-nowrap">更新至{comic.chapters}话</span>
        </div>
      )}
    </Link>
  );
}